import { pageCtaContent } from "../../../data/ctaContent";
import PrimaryButton from "../../ui/PrimaryButton";
import SecondaryButton from "../../ui/SecondaryButton";

function EnquiryCTA() {
  const content = pageCtaContent.home;

  return (
    <section className="bg-[#002147] py-24 sm:py-28">
      <div className="mx-auto w-full max-w-4xl px-5 text-center sm:px-6 lg:px-10">
        <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-gold">
          {content.badge}
        </p>
        <h2 className="mt-6 text-4xl font-semibold leading-tight text-white sm:text-6xl">
          {content.title}
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-white">
          {content.description}
        </p>

        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <PrimaryButton showArrow to={content.primaryCta.to}>
            {content.primaryCta.label}
          </PrimaryButton>
          <SecondaryButton
            to={content.secondaryCta.to}
            className="border-brand-gold/60 bg-transparent text-brand-gold hover:border-brand-gold hover:bg-brand-gold hover:text-brand-navy"
          >
            {content.secondaryCta.label}
          </SecondaryButton>
        </div>
      </div>
    </section>
  );
}

export default EnquiryCTA;
